import * as o from "react";
import n from "../lib/IconBase.es.js";
import a from "../defs/Monitor.es.js";
const r = o.forwardRef((t, e) => /* @__PURE__ */ o.createElement(n, { ref: e, ...t, weights: a }));
r.displayName = "MonitorIcon";
const c = r;
export {
  c as Monitor,
  r as MonitorIcon
};
